<mat-form-field appearance="outline" subscriptSizing="dynamic" class="user-picker">
  <mat-chip-grid #chipGrid [disabled]="disabled" [attr.aria-label]="ariaLabel">
    <mat-chip-row *ngFor="let user of chips; trackBy: trackByUser" (removed)="remove(user)">
      {{ user.full_name }}
      <button matChipRemove [attr.aria-label]="'Remove ' + user.full_name">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input
      #userInput
      [placeholder]="disabled && disabledPlaceholder ? disabledPlaceholder : placeholder"
      [disabled]="disabled"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="userAuto"
      (focus)="filterOptions(userInput.value)"
      (input)="filterOptions(userInput.value)"
      (blur)="onBlur()" />
  </mat-chip-grid>
  <mat-autocomplete #userAuto (optionSelected)="add($event, userInput)">
    <mat-option *ngFor="let user of options; trackBy: trackByUser" [value]="user">
      {{ user.full_name }}
      <span class="option-position">{{ user.position }}</span>
    </mat-option>
    <mat-option *ngIf="options.length === 0" disabled>No matching users</mat-option>
  </mat-autocomplete>
</mat-form-field>
